// import state from '../state/state'

export default {
  // 更新菜单
  freshMenu: function(state, { flag }) {
    state.isfreshMenu = flag
  },
  // 更新按钮的显示列表
  updateBtn: function(state, list) {
    state.buttonList = list
  }
  // 切换主题
  // changeTheme: function(state, type) {
  //   state.theme = type
  // }
}
